module.exports = __webpack_public_path__ + "ed96d52cc1dd2b71bc31cd8351fab996.MP3";